import Footer from "./components/Footer";
import Navbar from "./components/Navbar";
import Home from "./screens/Home";

function App() {
  return (
    <div className="bg-primary h-fit w-full text-white">
      <Navbar />
      <Home />
      <Footer />
    </div>
  );
}

export default App;
